import { sendHttpRequest } from "lib/fetcher";

export async function getAudioTemplateList() {
  return await sendHttpRequest({
    method: "get",
    url: "/mam/templates?withAsset=true",
  });
}
export async function saveTemplate(name, mediaAssets) {
  return await sendHttpRequest({
    method: "post",
    url: "/mam/templates",
    data: {
      name,
      mediaAssets,
    },
  });
}
export async function updateTemplate(id, name, mediaAssetIds) {
  return await sendHttpRequest({
    method: "put",
    url: "/mam/template/" + id,
    data: {
      name,
      mediaAssetIds,
    },
  });
}
export async function deleteTemplate(id) {
  return await sendHttpRequest({
    method: "delete",
    url: "/mam/template/" + id,
  });
}
